// extracted by mini-css-extract-plugin
export default {"EmailRegister":"EmailRegisterInner_EmailRegister__+ZvoH"};